// Search event — tracks search submissions on the search results page

import { pushAdobeEvent } from './core';
import { getCurrentPagePayload } from './pageLoad';

// How the user initiated the search — 'typed' for free-text input, 'suggestion' for autocomplete selection
export type SearchType = 'typed' | 'suggested';

export type SearchParams = {
  searchTerm: string;
  resultsValue: number | string;
  searchType?: SearchType;
};

// Short-lived hint of how the next tracked search was initiated; survives SPA route changes but not full reloads
let _pendingSearchType: SearchType | null = null;

// Records how the next tracked search was initiated; call right before triggering the search navigation
export const setPendingSearchType = (type: SearchType): void => {
  _pendingSearchType = type;
};

// Returns the pending search type and clears it so subsequent reads don't re-use a stale value
export const consumePendingSearchType = (): SearchType | null => {
  const type = _pendingSearchType;
  _pendingSearchType = null;
  return type;
};

// Pushes a Search event to the Adobe Client Data Layer — searchTerm + resultsValue required, searchType defaults to 'typed'
export const trackAdobeSearch = (params: SearchParams): void => {
  const eventName = 'Search';
  const page = getCurrentPagePayload();
  pushAdobeEvent({
    event: eventName,
    eventName,
    eventDesc: `${eventName} - ${params.searchTerm}`,
    ...(page && { page }),
    search: {
      searchType: params.searchType ?? 'typed',
      resultsValue: params.searchType === 'suggested' ? null : String(params.resultsValue),
    },
  });
};
